module.exports = __webpack_public_path__ + "img/icon-smiley0.svg";